import { render, staticRenderFns } from "./PainelItemVisualizacao.vue?vue&type=template&id=13ad5b6e&scoped=true"
import script from "./PainelItemVisualizacao.vue?vue&type=script&lang=js"
export * from "./PainelItemVisualizacao.vue?vue&type=script&lang=js"
import style0 from "./PainelItemVisualizacao.vue?vue&type=style&index=0&id=13ad5b6e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ad5b6e",
  null
  
)

export default component.exports